
import {  useState } from "react";
// import { E_immatriculation } from "../../../../constants/constant";
// import axios from "axios";

import Label from "../../../../components/title/label";
import Input from "../../../../components/input/Input";
import Checkbox from "../../../../components/button/Checkbox";
import { Link } from "react-router-dom";
import { RiArrowGoBackFill } from "react-icons/ri";
import { Navbar } from "../../../../components/navbar/Navbar";
import BackButton from "../../../../components/button/BackButton";


function RenseignementGeneral() {
    const selectedData = localStorage.getItem("selectedDataPriseEnCharge");
    const [contribuableData] = useState(JSON.parse(selectedData ));

    console.log("contribuableData :" , contribuableData)
  
    // useEffect(() => {
    //   const fetchContribuable = async () => {
    //     try {
    //       const response = await axios.get(`${E_immatriculation}/contribuable/valide/${contribuableData.id}`);
    //       setContribuable(response.data);
    //       console.log("redponse" ,response)
    //     } catch (error) {
    //       console.error("Erreur lors de la récupération des données:", error);
    //     }
    //   };
  
    //   fetchContribuable();
    // }, [contribuableData]);
  
  
    
  

  // Navbar content
  const contentNavbar = (
    <nav className="flex items-center justify-between">
     <div className="text-white">
     Principaux renseignements
     </div>
      <BackButton to="/SituationGeographiqueIm"></BackButton>
    </nav>
  );
    return (
      <div className=" w-full h-screen bg-[#212122]">
            <Navbar content={contentNavbar} />
            <main className="">
              <div className={`flex flex-col`}>
          
          
          <div className="flex justify-enter bg- w-full p-4">
            <div className="flex flex-col w-full max-w-3xl mx-auto">
              <div className="flex justify-between mt-6">
                <Label text="Raison Social" />
                <Input
                  type="text"
                  value={contribuableData.raison_social}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Type" />
                <div className="flex gap-4">
                  {["Personne physique", "Personne morale"].map((type) => (
                    <label key={type} className="flex text-white items-center">
                      <input
                        type="radio"
                        value={type}
                        checked={contribuableData.type === type}

                        className="mr-2"
                      />
                      {type}
                    </label>
                  ))}
                </div>
              </div>
  
              {contribuableData.type === "Personne physique" && (
                <>
                  <div className="flex justify-between mt-6">
                    <Label text="Situation matrimoniale" />
                    <Input
                      type="text"
                      value={contribuableData.situation_matrimoniale}

                    />
                  </div>
  
                  <div className="flex justify-between mt-6">
                    <Label text="Sexe" />
                    <div className="flex gap-4">
                      {["Masculin", "Feminin"].map((sexe) => (
                        <Checkbox
                          key={sexe}
                          label={sexe}
                          checked={contribuableData.sexe === sexe}

                        />
                      ))}
                    </div>
                  </div>
  
                  <div className="flex justify-between mt-6">
                    <Label text="Etranger" />
                    <div className="flex gap-4">
                      <Checkbox
                        label="Oui"
                        checked={contribuableData.etranger}

                      />
                      <Checkbox
                        label="Non"
                        checked={!contribuableData.etranger}

                      />
                    </div>
                  </div>
  
                  {!contribuableData.etranger ? (
                    <>
                      <div className="flex justify-between mt-6">
                        <Label text="CIN" />
                        <Input
                          type="text"
                          value={contribuableData.cin}

                        />
                      </div>
  
                      <div className="flex justify-between mt-6">
                        <Label text="Date de délivrance" />
                        <Input
                          type="date"
                          value={contribuableData.date_de_delivrance_cin}

                        />
                      </div>
  
                      <div className="flex justify-between mt-6">
                        <Label text="Lieu de délivrance" />
                        <Input
                          type="text"
                          value={contribuableData.lieu_de_delivrance_cin}

                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex justify-between mt-6">
                        <Label text="Numéro passport" />
                        <Input
                          type="text"
                          value={contribuableData.numero_passport}

                        />
                      </div>
  
                      <div className="flex justify-between mt-6">
                        <Label text="Date de délivrance" />
                        <Input
                          type="date"
                          value={contribuableData.date_de_delivrance_passeport}

                        />
                      </div>
                    </>
                  )}
  
                  <div className="flex justify-between mt-6">
                    <Label text="Date naissance" />
                    <Input
                      type="date"
                      value={contribuableData.date_de_naissance}

                    />
                  </div>
  
                  <div className="flex justify-between mt-6">
                    <Label text="Lieu naissance" />
                    <Input
                      type="text"
                      value={contribuableData.lieu_de_naissance}

                    />
                  </div>
                </>
              )}
  
              <div className="flex justify-between mt-6">
                <Label text="Forme juridique" />
                <Input
                  type="text"
                  value={contribuableData.forme_juridique}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Régime Fiscale" />
                <Input
                  type="text"
                  value={contribuableData.regime_fiscal}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Date de Création" />
                <Input
                  type="date"
                  value={contribuableData.date_creation}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Capital en Ar" />
                <Input
                  type="text"
                  value={contribuableData.capital}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="RIB" />
                <div className="flex gap-4">
                  {["Disponible", "Pas encore"].map((rib) => (
                    <Checkbox
                      key={rib}
                      label={rib}
                      checked={contribuableData.RIB === rib}

                    />
                  ))}
                </div>
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Compte bancaire" />
                <Input

                  type="text"
                  value={contribuableData.numero_compte_bancaire}

                />
              </div>
  
              <div className="flex justify-between mt-6 mb-6">
  
                <Link
                  to="/SituationGeographiqueIm"
                  className="border-[2px] border-white w-40 p-2  text-white rounded hover:bg-black/70 hover:text-white flex items-center justify-center"
                >
                  <RiArrowGoBackFill className="text-2xl text-white mr-2" />
                  Fermer
                </Link>
              </div>
            </div>
          </div>
        </div>
        </main>
          </div>
    );
  }
  
  
export default RenseignementGeneral